import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function CheckmarxConnectForm({ onSubmit, guideMode, loading }) {
  const formInitialValues = {
    api_key: "",
    portal_url: "https://us.ast.checkmarx.net", // default set to US2 environment
    tenant_name: "",
  };
  const formCheckoutSchema = yup.object().shape({
    api_key: yup.string().required("required"),
    portal_url: yup.string().url("Must be a valid URL").required("required"),
    tenant_name: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="portal_url"
                label="Web Portal URL"
                value={values.portal_url}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.portal_url && !!errors.portal_url}
                helperText={touched.portal_url && errors.portal_url}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                type={showSecret ? "text" : "password"}
                variant="filled"
                name="api_key"
                label="API Key"
                value={values.api_key}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.api_key && !!errors.api_key}
                helperText={touched.api_key && errors.api_key}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="tenant_name"
                label="Tenant Account Name"
                value={values.tenant_name}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.tenant_name && !!errors.tenant_name}
                helperText={touched.tenant_name && errors.tenant_name}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode || loading}>
                {loading ? "Connecting..." : "Connect"}
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
